<template>
  <v-card class="pa-6">
    <v-card-title class="text-uppercase">
      <v-row class="my-1 justify-space-between align-center">
        <div>{{ isEdit ? 'Editar registro de servicio' : 'Nuevo registro de servicio' }}</div>
        <v-switch
          v-if="!isRefundStub"
          v-model="isPawerUser"
          label="Usuario Pawer"
          dense
          hide-details="auto"
          :disabled="isEdit"
          @change="clearAll"
        ></v-switch>
        <v-btn text color="primary" rounded @click="closeDialog">Cerrar</v-btn>
      </v-row>
    </v-card-title>

    <hr class="my-3" />
    <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>

    <v-form ref="newServiceRec" @submit.prevent>
      <v-container>
        <!-- ! STUB DE REEMBOLSO: sin tutor, membresía, servicio ni montos (FR-018) -->
        <v-col v-if="isRefundStub">
          <v-row class="my-1">
            <v-col cols="6">
              <div class="pw-label">Tutor</div>
              <div class="pw-value">Sin tutor</div>
            </v-col>
            <v-col cols="6">
              <div class="pw-label">Membresía</div>
              <div class="pw-value">Sin membresía</div>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col cols="4">
              <v-menu
                ref="dateMenu"
                v-model="dateMenu"
                :close-on-content-click="false"
                :return-value.sync="usedAt"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    dense
                    v-model="dateFormated"
                    label="Cuando fue usado"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="usedAt" no-title scrollable :max="today">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="dateMenu = false">
                    Cerrar
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.dateMenu.save(usedAt)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col cols="8">
              <v-textarea
                label="Descripción (opcional)"
                v-model="description"
                outlined
                dense
                hide-details="auto"
                counter
                maxlength="100"
                rows="3"
              ></v-textarea>
            </v-col>
            <v-col cols="4">
              <v-radio-group label="Tipo de operación" v-model="operationType" class="ma-0" dense>
                <v-radio label="Reembolso" value="refund" dense></v-radio>
                <v-radio label="Operativo" value="operational" dense></v-radio>
                <v-radio label="Upsell" value="upsell" dense></v-radio>
                <v-radio label="Telemedicina" value="telemedicine" dense></v-radio>
                <v-radio label="PetMed" value="petmed" dense></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>

        <!-- ! CAMPO DE USUARIOS DE PAWER -->
        <v-col v-else-if="isPawerUser">
          <v-row class="my-1" v-if="!isEdit">
            <v-col cols="12">
              <v-text-field
                label="Buscar usuario"
                v-model="search"
                :required="isPawerUser"
                outlined
                dense
                hide-details="auto"
                append-icon="mdi-magnify"
                placeholder="Nombre, apellido, email o RUT"
                @click:append="searchReq"
                @keyup.enter="searchReq"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col cols="6" class="my-0" v-if="usersFinded.length > 0">
              <!-- ! USUARIOS ENCONTRADOS-->
              <v-select
                v-model="selectedUser"
                :disabled="isEdit || usersFinded.length === 0"
                :items="usersFinded"
                label="Elige un usuario"
                dense
                outlined
                :required="isPawerUser"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">
                      {{ item.name }} {{ item.surname }} - {{ item.email }}{{ item.rut ? ` - RUT: ${item.rut}` : '' }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-slot:selection="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">
                      {{ item.name }} {{ item.surname }} - {{ item.email }}{{ item.rut ? ` - RUT: ${item.rut}` : '' }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-select>
            </v-col>
            <v-col v-else>
              <span v-if="noDataMsg">{{ noDataMsg }}</span>
            </v-col>
            <v-col cols="6" class="my-0" v-if="selectedUser && !unregisteredMembership">
              <!-- ! MEMBRESIAS DEL USUARIO ENCONTRADO-->
              <v-select
                v-model="selectedMembership"
                :disabled="isEdit || !membershipItems.length"
                :items="membershipItems"
                label="Elige una membresia"
                dense
                outlined
                :required="isPawerUser && !unregisteredMembership"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">
                      {{ item.pet.name }}
                      <v-icon v-if="item.pet.species === 'dog'" right> mdi-dog </v-icon>
                      <v-icon v-else right> mdi-cat </v-icon>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <template v-slot:selection="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">
                      {{ item.pet.name }}
                      <v-icon v-if="item.pet.species === 'dog'" right> mdi-dog </v-icon>
                      <v-icon v-else right> mdi-cat </v-icon>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row class="my-0 mt-n8">
            <v-col cols="6" v-if="selectedUser">
                <v-checkbox 
                v-model="unregisteredMembership" 
                label="Membresía no registrada ($5.990)"
                :disabled="isEdit"
                dense
                hide-details="auto"
                @change="handleUnregisteredMembershipChange"
                ></v-checkbox>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col cols="6" v-if="selectedUser && unregisteredMembership">
                <v-text-field
                label="Nombre de la mascota"
                v-model="unregisteredPetName"
                outlined
                dense
                hide-details="auto"
                :required="unregisteredMembership"
                placeholder="Ej: Firulais"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <!-- !Elegir servicio utilizado -->
            <!-- Servicios de Plan -->
            <v-col cols="4" v-if="(selectedMembership || unregisteredMembership) && !showAttendanceForm">
              <v-select
                v-model="selectedServicePlan"
                :disabled="!selectedMembership"
                :items="selectedMembership ? selectedMembership.plan.servicePlanDetails : []"
                label="Elige el servicio utilizado"
                dense
                outlined
                :required="isPawerUser && !selectedIsolatedService"
                @change="servicePlanPicked"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">
                      {{ item.service.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <template v-slot:selection="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">
                      {{ item.service.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-select>
            </v-col>
            <!-- Servicios isolados (de pawer a domicilio x ej) -->
            <v-col
              cols="4"
              v-if="(selectedMembership || unregisteredMembership) && !showAttendanceForm && !editsPetmedInPlace"
            >
              <v-select
                v-model="selectedIsolatedService"
                :items="isolatedServices"
                label="Otros servicios"
                dense
                outlined
                :required="isPawerUser && !selectedServicePlan"
                @change="isolatedPicked"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">
                      {{ item.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <template v-slot:selection="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">
                      {{ item.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-select>
            </v-col>

            <!-- ! DATE PICKER -->
            <v-col cols="4" v-if="selectedMembership || unregisteredMembership">
              <v-menu
                ref="dateMenu"
                v-model="dateMenu"
                :close-on-content-click="false"
                :return-value.sync="usedAt"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    dense
                    v-model="dateFormated"
                    label="Cuando fue usado"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="usedAt" no-title scrollable :max="today">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="dateMenu = false">
                    Cerrar
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.dateMenu.save(usedAt)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row class="my-0" v-if="!showAttendanceForm">
            <v-col cols="4" v-if="selectedMembership || unregisteredMembership">
              <v-text-field
                label="Gasto del usuario:"
                v-model="userSpends"
                outlined
                dense
                hide-details="auto"
                type="number"
                prefix="$"
                hide-spin-buttons
              ></v-text-field>
            </v-col>

            <v-col cols="4" v-if="selectedMembership || unregisteredMembership">
              <v-text-field
                :disabled="!refundable"
                label="Monto del egreso"
                v-model="refundedAmount"
                outlined
                dense
                hide-details="auto"
                type="number"
                prefix="$"
                hide-spin-buttons
              ></v-text-field>
            </v-col>

            <v-col cols="4" v-if="selectedMembership || unregisteredMembership">
              <v-checkbox dense v-model="refundable" label="¿Genera egreso?"></v-checkbox>
            </v-col>
          </v-row>

          <v-row class="my-0">
            <v-col cols="8" v-if="selectedMembership || unregisteredMembership">
              <div class="text-subtitle-2 black--text text--darken-1 mb-1">
                <span class="font-weight-bold">Descripción Admin</span>
                <span class="font-weight-regular" style="margin-left: 4px;">(visible solo equipo de Pawer)</span>
              </div>
              <v-textarea
                label="Descripción (opcional)"
                v-model="description"
                outlined
                dense
                hide-details="auto"
                counter
                maxlength="100"
                rows="3"
              ></v-textarea>
              <div v-if="!isEdit" class="text-subtitle-2 black--text text--darken-1 mb-1">
                <span class="font-weight-bold">Descripción Ficha Médica</span>
                <span class="font-weight-regular" style="margin-left: 4px;">(visible para el usuario)</span>
              </div>
              <v-textarea
                v-if="!isEdit"
                label="Anotaciones (opcional)"
                v-model="userDescription"
                outlined
                dense
                hide-details="auto"
                counter
                maxlength="1000"
                rows="5"
              ></v-textarea>
            </v-col>
            <v-col cols="4" v-if="selectedMembership || unregisteredMembership">
              <v-radio-group label="Tipo de operación" v-model="operationType" class="ma-0" dense>
                <v-radio label="Reembolso" value="refund" dense></v-radio>
                <v-radio label="Operativo" value="operational" dense></v-radio>
                <v-radio label="Upsell" value="upsell" dense></v-radio>
                <v-radio label="Telemedicina" value="telemedicine" dense></v-radio>
                <v-radio
                  v-if="selectedMembership && !unregisteredMembership"
                  label="PetMed"
                  value="petmed"
                  dense
                ></v-radio>
              </v-radio-group>
              <p v-if="(selectedMembership || unregisteredMembership) && !operationType" style="color: red; font-size: 12px;">
                Debes seleccionar un tipo de operación.
              </p>
            </v-col>
          </v-row>

          <!-- PetMed con atención: corregir clínica/vet/montos rehace la atención (anula la factura) -->
          <v-row class="my-0" v-if="hasAttendance && isPetmed">
            <v-col cols="12">
              <v-checkbox
                v-model="redoAttendance"
                label="Corregir la atención (clínica, veterinario y montos)"
                dense
                hide-details="auto"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row class="my-0" v-if="showAttendanceForm && selectedMembership && (!redoAttendance || currentAttendance)">
            <v-col cols="12">
              <petmed-attendance-form
                :membership="selectedMembership"
                :initial="redoAttendance ? attendanceInitial : null"
                :exclude-service-record-id="excludedRecordId"
                :allow-exhausted="isEdit"
                :record-amounts="recordAmounts"
                @input="petmedAttendance = $event"
                @validity-change="petmedValid = $event"
              ></petmed-attendance-form>
            </v-col>
          </v-row>
        </v-col>

        <!-- ! CAMPOS DE USUARIO EXTERNO-->

        <v-col v-else>
          <v-row>
            <v-col cols="4">
              <v-text-field
                label="Nombre y apellido"
                :required="!isPawerUser"
                v-model="fullName"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <!-- ! Servicios isolados (de pawer a domicilio x ej) -->
            <v-col cols="4" v-if="!isPetmed">
              <v-select
                v-model="selectedIsolatedService"
                :items="isolatedServices"
                label="Elige el servicio utilizado"
                dense
                outlined
                :required="!isPawerUser"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">
                      {{ item.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <template v-slot:selection="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">
                      {{ item.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-select>
            </v-col>
            <!-- !date -->
            <v-col cols="4">
              <v-menu
                ref="dateMenu"
                dense
                v-model="dateMenu"
                :close-on-content-click="false"
                :return-value.sync="usedAt"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFormated"
                    label="Cuando fue usado"
                    prepend-icon="mdi-calendar"
                    readonly
                    dense
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="usedAt" no-title scrollable :max="today">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="dateMenu = false">
                    Cerrar
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.dateMenu.save(usedAt)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row v-if="!isPetmed">
            <v-col cols="4">
              <v-text-field
                label="Gasto del usuario:"
                v-model="userSpends"
                outlined
                dense
                hide-details="auto"
                type="number"
                prefix="$"
                hide-spin-buttons
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :disabled="!refundable"
                label="Monto del egreso"
                v-model="refundedAmount"
                outlined
                dense
                hide-details="auto"
                type="number"
                prefix="$"
                hide-spin-buttons
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-checkbox dense v-model="refundable" label="¿Genera egreso?"></v-checkbox>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col cols="8">
              <v-textarea
                label="Descripción (opcional)"
                v-model="description"
                outlined
                dense
                hide-details="auto"
                counter
                maxlength="100"
                rows="3"
              ></v-textarea>
            </v-col>

            <v-col cols="4">
              <v-radio-group
                label="Tipo de operación"
                v-model="operationType"
                class="ma-0"
                dense
                :error="!operationType"
                :error-messages="!operationType ? 'Debes seleccionar un tipo de operación.' : ''"
              >
                <v-radio label="Reembolso" value="refund" dense></v-radio>
                <v-radio label="Operativo" value="operational" dense></v-radio>
                <v-radio v-if="isEdit" label="PetMed" value="petmed" dense></v-radio>
              </v-radio-group>
              <!-- <p v-if="!selectedMembership && !operationType" style="color: red; font-size: 12px;">
                Debes seleccionar un tipo de operación.
              </p> -->
            </v-col>
          </v-row>
        </v-col>
        <!-- ! CONVERSIÓN A PETMED SIN MEMBRESÍA (stub de reembolso o usuario externo): se elige
             el tutor y la membresía de la atención -->
        <v-col v-if="picksMembership">
          <v-row class="my-1">
            <v-col cols="12">
              <v-text-field
                label="Buscar usuario"
                v-model="search"
                outlined
                dense
                hide-details="auto"
                append-icon="mdi-magnify"
                placeholder="Nombre, apellido, email o RUT"
                @click:append="pickerSearch"
                @keyup.enter="pickerSearch"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col cols="6" class="my-0" v-if="usersFinded.length > 0">
              <v-select
                v-model="selectedUser"
                :items="usersFinded"
                label="Elige un usuario"
                dense
                outlined
                @change="selectedMembership = null"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">
                      {{ item.name }} {{ item.surname }} - {{ item.email }}{{ item.rut ? ` - RUT: ${item.rut}` : '' }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-slot:selection="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">
                      {{ item.name }} {{ item.surname }} - {{ item.email }}{{ item.rut ? ` - RUT: ${item.rut}` : '' }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-select>
            </v-col>
            <v-col v-else>
              <span v-if="noDataMsg">{{ noDataMsg }}</span>
            </v-col>
            <v-col cols="6" class="my-0" v-if="selectedUser">
              <v-select
                v-model="selectedMembership"
                :disabled="!membershipItems.length"
                :items="membershipItems"
                label="Elige una membresia"
                dense
                outlined
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">
                      {{ item.pet.name }}
                      <v-icon v-if="item.pet.species === 'dog'" right> mdi-dog </v-icon>
                      <v-icon v-else right> mdi-cat </v-icon>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-slot:selection="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">
                      {{ item.pet.name }}
                      <v-icon v-if="item.pet.species === 'dog'" right> mdi-dog </v-icon>
                      <v-icon v-else right> mdi-cat </v-icon>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row class="my-0" v-if="selectedMembership">
            <v-col cols="12">
              <petmed-attendance-form
                :membership="selectedMembership"
                :exclude-service-record-id="excludedRecordId"
                :allow-exhausted="isEdit"
                :record-amounts="recordAmounts"
                @input="petmedAttendance = $event"
                @validity-change="petmedValid = $event"
              ></petmed-attendance-form>
            </v-col>
          </v-row>
        </v-col>
      </v-container>
    </v-form>

    <!-- Edición: el cambio impacta registros y métricas ya calculados (FR-006) -->
    <v-alert v-if="isEdit" type="warning" text dense class="mx-3">
      <div>
        Editar este registro puede alterar los registros y métricas de Pawer (uso de coberturas,
        egresos y reportes). Verifica los datos antes de confirmar.
      </div>
      <div v-for="line in editWarnings" :key="line" class="mt-1">{{ line }}</div>
    </v-alert>

    <v-card-actions class="justify-end">
      <v-btn text color="primary" rounded @click="closeDialog">Cancelar</v-btn>
      <v-btn :disabled="!isValid || loading" color="primary" rounded @click="submit">
        {{ isEdit ? 'Editar' : 'Crear registro' }}
      </v-btn>
    </v-card-actions>

    <v-snackbar v-model="snackbar" :timeout="3000">
      {{ creationMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import ServicesRecords from '../services/services_records.service';
import UsersService from '../services/users.service';
import ClinicsService from '../services/clinics.service';
import PetmedAttendanceForm from './PetmedAttendanceForm.vue';
import {
  recordVariant,
  parseExternalDescription,
  parseUnregisteredDescription,
  composeExternalDescription,
  composeUnregisteredDescription,
  recordDateForInput,
  buildRecordPatch
} from '../utils/services-record.utils';
import moment from 'moment';
import '../main';

export default {
  name: 'ServiceRecordMaintainer',
  components: { PetmedAttendanceForm },
  props: {
    activeServices: { type: Array, default: () => [] },
    isolatedServices: { type: Array, default: () => [] },
    refreshParent: { type: Function, default: () => {} },
    // Registro a editar (024-services-record-edit). null = modo creación.
    serviceRecord: { type: Object, default: null }
  },
  data() {
    return {
      loading: false,
      noDataMsg: null,
      snackbar: false,
      creationMsg: null,
      usedAt: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateMenu: false,
      today: moment(new Date(Date.now())).format('YYYY-MM-DD'),
      search: null,
      isPawerUser: true,
      description: null,
      userDescription: null,
      refundable: false,
      userSpends: null,
      refundedAmount: null,
      //!
      usersFinded: [],
      selectedUser: null,
      userMemberships: [],
      selectedMembership: null,
      selectedServicePlan: null,
      selectedIsolatedService: null,
      // ! If particular user:
      fullName: null,
      operationType: null,
      unregisteredMembership: false,
      unregisteredPetName: null,
      // ! PetMed: payload y validez emitidos por PetmedAttendanceForm
      petmedAttendance: null,
      petmedValid: false,
      // ! Edición: foto del formulario recién precargado, base del patch parcial
      original: null,
      // ! Edición de un PetMed con atención: rehacer la atención con datos corregidos
      redoAttendance: false,
      currentAttendance: null
    };
  },
  computed: {
    isPetmed() {
      return this.operationType === 'petmed';
    },
    isEdit() {
      return !!this.serviceRecord;
    },
    variant() {
      return recordVariant(this.serviceRecord);
    },
    isRefundStub() {
      return this.variant === 'refund';
    },
    hasAttendance() {
      return !!(this.serviceRecord && this.serviceRecord.attendanceId);
    },
    // Vínculo con una solicitud de reembolso, tenga o no membresía el registro.
    isRefundLinked() {
      return !!(this.serviceRecord && this.serviceRecord.refundRequestId);
    },
    // PetMed con atención editado sin rehacerla: solo campos comunes (FR-017).
    editsPetmedInPlace() {
      return this.hasAttendance && this.isPetmed && !this.redoAttendance;
    },
    // Formulario de atención: al crear un PetMed, al editar un registro que queda PetMed sin
    // atención (conversión o PetMed sin atención) y al rehacer la atención existente.
    showAttendanceForm() {
      if (!this.isPetmed) return false;
      return !this.isEdit || !this.hasAttendance || this.redoAttendance;
    },
    // Registro que termina PetMed y aún no tiene atención: hay que crearla (FR-015).
    convertsToPetmed() {
      return this.isEdit && this.isPetmed && !this.hasAttendance;
    },
    // El uso del propio registro no cuenta en los cupos de los servicios de la clínica (FR-023).
    excludedRecordId() {
      return this.isEdit ? this.serviceRecord.id : null;
    },
    // Montos originales del registro para prellenar un servicio con el tope usado (FR-024).
    recordAmounts() {
      if (!this.isEdit) return null;
      const { refundedAmount, userSpends } = this.serviceRecord;
      return { refundedAmount: refundedAmount ?? null, userSpends: userSpends ?? null };
    },
    // Stub de reembolso o usuario externo pasando a PetMed: la atención necesita una membresía.
    // Membresía no registrada queda fuera (decisión del usuario).
    picksMembership() {
      return this.convertsToPetmed && (this.variant === 'refund' || this.variant === 'external');
    },
    leavesPetmed() {
      return this.hasAttendance && !this.isPetmed;
    },
    // Atención actual (GET .../attendance) para precargar el formulario al rehacerla.
    attendanceInitial() {
      return this.currentAttendance;
    },
    membershipItems() {
      if (this.isEdit && !this.picksMembership) return this.selectedMembership ? [this.selectedMembership] : [];
      return (this.selectedUser && this.selectedUser.memberships) || [];
    },
    recordPatch() {
      if (!this.isEdit || !this.original) return {};
      return buildRecordPatch(this.original, this.formSnapshot(), this.variant, {
        attendance: this.isEdit && this.showAttendanceForm ? this.petmedAttendance : null,
        membershipId: this.picksMembership && this.selectedMembership ? this.selectedMembership.id : null
      });
    },
    hasChanges() {
      return Object.keys(this.recordPatch).length > 0;
    },
    editWarnings() {
      const lines = [];
      if (this.editsPetmedInPlace) {
        lines.push('Los montos editados dejarán de coincidir con la factura de la clínica.');
      }
      if (this.leavesPetmed) {
        lines.push('Se anulará la factura de la clínica y la atención dejará de contar en las métricas PetMed.');
      }
      if (this.convertsToPetmed) {
        lines.push('La cobertura final se recalcula según la carencia del plan.');
      }
      if (this.redoAttendance && this.isPetmed) {
        lines.push('Se anulará la factura actual y se creará una nueva atención con los datos corregidos.');
      }
      if (this.picksMembership) {
        lines.push('El registro quedará asociado al tutor y la membresía elegidos.');
      }
      // Evita el doble pago tutor + clínica: el backend desvincula el registro de la solicitud.
      if (this.convertsToPetmed && this.isRefundLinked) {
        lines.push(
          'El registro se desvinculará de la solicitud de reembolso. Recházala manualmente en Reembolsos para evitar un doble pago.'
        );
      }
      if (this.isRefundLinked) {
        lines.push('La fecha de uso alimenta el reporte de siniestros para la aseguradora.');
      }
      if (this.isRefundStub) {
        lines.push('Los montos se corrigen en la solicitud de reembolso.');
      }
      return lines;
    },
    isValid() {
      const valid = this.isFormValid();
      return this.isEdit ? valid && this.hasChanges : valid;
    },
    dateFormated() {
      if (this.usedAt == null) {
        return null;
      }
      return moment(this.usedAt).format('DD/MM/YYYY');
    }
  },
  watch: {
    redoAttendance(value) {
      if (value) this.loadCurrentAttendance();
    },
    // v-dialog monta el contenido recién al abrirse: immediate cubre la primera apertura (research R2).
    serviceRecord: {
      immediate: true,
      handler(record) {
        if (record) this.loadRecord(record);
        else this.resetForm();
      }
    }
  },
  mounted() {
    this.$refs.newServiceRec.resetValidation();
  },
  methods: {
    isFormValid() {
      if (this.picksMembership) return !!this.selectedMembership && this.petmedValid && !!this.usedAt;
      if (this.isRefundStub) return !!this.operationType && !!this.usedAt;
      if (this.isPawerUser && this.showAttendanceForm) {
        return (
          this.selectedMembership !== null &&
          !this.unregisteredMembership &&
          this.petmedValid &&
          !!this.usedAt
        );
      }
      if (this.isPawerUser) {
        return (
          (this.selectedMembership !== null || this.unregisteredMembership) &&
          (this.selectedServicePlan !== null || this.selectedIsolatedService !== null) &&
          this.operationType !== null
        );
      } else {
        return (
          this.fullName !== null &&
          this.fullName !== '' &&
          this.fullName.length > 2 &&
          this.selectedIsolatedService !== null &&
          this.operationType !== null
        );
      }
    },
    // Estado del formulario en la forma del registro; la descripción se recompone igual que en create().
    formSnapshot() {
      let description = this.description || null;
      if (!this.isPawerUser) description = composeExternalDescription(this.fullName, this.description);
      else if (this.unregisteredMembership) {
        description = composeUnregisteredDescription(this.unregisteredPetName, this.description);
      }
      return {
        servicePlanId: this.selectedServicePlan ? this.selectedServicePlan.id : null,
        isolatedServiceId: this.selectedIsolatedService ? this.selectedIsolatedService.id : null,
        userSpends: this.userSpends,
        refundedAmount: this.refundable ? this.refundedAmount : null,
        refundable: this.refundable,
        description,
        operationType: this.operationType,
        usedAt: this.usedAt
      };
    },
    loadRecord(record) {
      this.clearAll();
      const variant = recordVariant(record);
      this.isPawerUser = variant !== 'external';
      this.usedAt = recordDateForInput(record.usedAt) || this.usedAt;
      this.userSpends = record.userSpends ?? null;
      this.refundedAmount = record.refundedAmount ?? null;
      this.refundable = !!record.refundable;
      this.operationType = record.operationType || null;
      this.selectedIsolatedService = this.findIsolatedService(record.isolatedServiceId);

      if (variant === 'membership' || variant === 'petmed') {
        const membership = record.membership;
        this.selectUser((membership && membership.user) || record.user);
        this.selectedMembership = membership || null;
        // Si el plan ya no incluye el servicio original queda vacío y hay que elegir otro (R6).
        const details = (membership && membership.plan && membership.plan.servicePlanDetails) || [];
        this.selectedServicePlan = details.find(d => d.id === record.servicePlanId) || null;
        this.description = record.description || null;
      } else if (variant === 'unregistered') {
        const parsed = parseUnregisteredDescription(record.description);
        this.selectUser(record.user);
        this.unregisteredMembership = true;
        this.unregisteredPetName = parsed.petName;
        this.description = parsed.description;
      } else if (variant === 'external') {
        const parsed = parseExternalDescription(record.description);
        this.fullName = parsed.fullName;
        this.description = parsed.description;
      } else {
        this.description = record.description || null;
      }
      this.original = this.formSnapshot();
    },
    // Rehacer solo se permite con la factura pendiente y una única línea: si trae servicios
    // propios de la clínica, anularla los borraría de su facturación.
    async loadCurrentAttendance() {
      this.loading = true;
      const res = await ServicesRecords.getAttendance(this.serviceRecord.id);
      this.loading = false;
      let blocked = null;
      if (res.status !== 'ok') blocked = 'No se pudo cargar la atención actual; inténtalo más tarde.';
      else if (res.data.invoiceStatus !== 'pending') {
        blocked = 'La atención ya fue pagada a la clínica; no se puede rehacer desde aquí.';
      } else if (res.data.lineItemCount !== 1) {
        blocked = 'La factura incluye otros servicios de la clínica; no se puede rehacer desde aquí.';
      }
      if (blocked) {
        this.redoAttendance = false;
        this.creationMsg = blocked;
        this.snackbar = true;
        return;
      }
      this.currentAttendance = res.data;
    },
    selectUser(user) {
      this.selectedUser = user || null;
      this.usersFinded = user ? [user] : [];
    },
    findIsolatedService(id) {
      if (!id) return null;
      return this.isolatedServices.find(s => s.id === id) || null;
    },
    // Al cerrar una edición el formulario vuelve al estado de creación (FR-011).
    resetForm() {
      this.isPawerUser = true;
      this.search = null;
      this.unregisteredPetName = null;
      this.clearAll();
    },
    clearAll() {
      this.noDataMsg = null;
      this.usersFinded = [];
      this.selectedUser = null;
      this.userMemberships = [];
      this.selectedMembership = null;
      this.selectedServicePlan = null;
      this.selectedIsolatedService = null;
      this.fullName = null;
      this.description = null;
      this.userDescription = null;
      this.operationType = null;
      this.refundable = false;
      this.userSpends = null;
      this.refundedAmount = null;
      this.unregisteredMembership = false;
      this.petmedAttendance = null;
      this.petmedValid = false;
      this.usedAt = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      this.original = null;
      this.redoAttendance = false;
      this.currentAttendance = null;
      // El watcher immediate de serviceRecord corre antes de que exista el ref.
      if (this.$refs.newServiceRec) this.$refs.newServiceRec.resetValidation();
    },
    handleUnregisteredMembershipChange() {
      if (this.unregisteredMembership) {
        this.selectedMembership = null;
        this.selectedServicePlan = null;
        if (this.isPetmed) this.operationType = null;
      } else {
        this.unregisteredPetName = null;
      }
    },
    closeDialog() {
      this.clearAll();
      this.$emit('close-dialog');
    },
    submit() {
      return this.isEdit ? this.update() : this.create();
    },
    async update() {
      this.loading = true;
      const res = await ServicesRecords.update(this.serviceRecord.id, this.recordPatch);
      this.loading = false;
      if (res.status === 'ok' || res.httpCode === 404) {
        // El snackbar propio queda oculto al cerrar el diálogo: el aviso lo muestra el padre.
        const message = res.status === 'ok' ? this.updateSuccessMessage(res.data) : 'El registro ya no existe.';
        this.$emit('record-updated', message);
        this.closeDialog();
        this.refreshParent();
        return;
      }
      this.creationMsg = this.updateErrorMessage(res);
      this.snackbar = true;
    },
    updateSuccessMessage(data) {
      let message = 'Registro actualizado';
      if ((this.convertsToPetmed || this.redoAttendance) && data && data.invoice) {
        const { pawerCoverageAmount, isInGracePeriod } = this.petmedAttendance;
        message = this.petmedSuccessMessage(pawerCoverageAmount, data, isInGracePeriod, 'actualizado');
      }
      const cap = data && data.capWarning;
      if (cap) {
        message = `${message}. El egreso supera el tope anual del plan (saldo: ${this.formatAmount(cap.remaining, cap.currency)}).`;
      }
      return message;
    },
    formatAmount(value, currency) {
      try {
        return new Intl.NumberFormat('es-CL', { style: 'currency', currency: currency || 'CLP' }).format(value);
      } catch (error) {
        // Monedas sin código ISO (p. ej. UF) se muestran tal cual.
        return `${value} ${currency}`;
      }
    },
    // Errores del PATCH admin (contracts/services-record-update.md): los nuevos traen `code`,
    // los de PetMed heredados mantienen el código como prefijo del mensaje.
    updateErrorMessage(res) {
      if ((res.message || '').includes('MEMBERSHIP_MISMATCH_REFUND')) {
        return 'La membresía elegida no corresponde a la de la solicitud de reembolso.';
      }
      const code = res.code || (res.message || '').split(':')[0].trim();
      const messages = {
        SERVICE_NOT_COVERED_BY_MEMBERSHIP_PLAN: 'El servicio no está cubierto por el plan de la membresía.',
        PETMED_REQUIRES_MEMBERSHIP: 'Solo un registro con membresía puede pasar a PetMed.',
        REFUND_RECORD_FIELD_NOT_EDITABLE:
          'En registros de reembolso solo se puede editar la fecha, la descripción y el tipo.',
        PETMED_INVOICE_NOT_PENDING:
          'La atención ya fue pagada a la clínica; no se puede cambiar el tipo desde aquí.',
        PETMED_ATTENDANCE_HAS_SIBLINGS:
          'La atención incluye otros servicios; no se puede cambiar el tipo desde aquí.',
        REFUND_ALREADY_APPROVED:
          'La solicitud de reembolso ya fue aprobada o pagada; no se puede pasar a PetMed.'
      };
      if (messages[code]) return messages[code];
      if (code === 'IMMUTABLE_FIELD') console.error('PATCH services-records rechazó un campo inmutable', res);
      if (code === 'PET_NOT_IN_MEMBERSHIP' || code === 'SERVICE_SPECIES_MISMATCH') return this.petmedErrorMessage(res);
      if ((res.message || '').startsWith('Doctor with id') || (res.message || '').startsWith('Clinic with id')) {
        return this.petmedErrorMessage(res);
      }
      if (res.httpCode === 401 || res.httpCode === 403) return 'No tienes permisos para editar registros.';
      if (res.httpCode === 400) return 'Revisa los datos del registro e inténtalo nuevamente.';
      return 'Algo salió mal, inténtalo más tarde.';
    },
    async create() {
      if (this.isPetmed) return this.createPetmedAttendance();
      try {
        this.loading = true;
        let query = {};
        if (this.isPawerUser) {
          const finalAdminDescription = this.unregisteredMembership
            ? composeUnregisteredDescription(this.unregisteredPetName, this.description)
            : this.description;
          const finalUserDescription = this.userDescription;
          query = {
            userId: this.unregisteredMembership ? this.selectedUser.id : null,
            membershipId: this.selectedMembership ? this.selectedMembership.id : null,
            servicePlanId: this.selectedServicePlan !== null ? this.selectedServicePlan.id : null,
            isolatedServiceId:
              this.selectedIsolatedService !== null ? this.selectedIsolatedService.id : null,
            userSpends: this.userSpends ? parseFloat(this.userSpends) : null,
            refundedAmount: this.refundedAmount ? parseFloat(this.refundedAmount) : null,
            description: finalAdminDescription,
            userDescription: finalUserDescription,
            refundable: this.refundable,
            operationType: this.operationType,
            usedAt: this.usedAt,
            unregisteredMembership: this.unregisteredMembership
          };
        } else {
          const fullAdminDescription = composeExternalDescription(this.fullName, this.description);
          query = {
            isolatedServiceId: this.selectedIsolatedService.id,
            userSpends: this.userSpends ? parseFloat(this.userSpends) : null,
            refundedAmount: this.refundedAmount ? parseFloat(this.refundedAmount) : null,
            description: fullAdminDescription,
            userDescription: this.userDescription,
            refundable: this.refundable,
            operationType: this.operationType,
            usedAt: this.usedAt
          };
        }
        await ServicesRecords.create(query);
        this.loading = false;
        this.creationMsg = 'Nuevo registro creado';
        this.snackbar = true;
        this.closeDialog();
        this.refreshParent();
      } catch (error) {
        this.loading = false;
        this.snackbar = true;
        this.creationMsg = 'Algo salio mal, intentalo mas tarde';
        this.refreshParent();
        console.log(error);
      }
    },
    // PetMed: crea invoice → attendance → services-record en una sola llamada. El éxito se
    // avisa al padre con `record-created` (mensaje) porque el snackbar de este componente
    // queda oculto al cerrarse el diálogo.
    async createPetmedAttendance() {
      this.loading = true;
      const { clinicId, pawerCoverageAmount, isInGracePeriod } = this.petmedAttendance;
      const res = await ClinicsService.createAttendance(clinicId, this.buildAttendancePayload());
      this.loading = false;
      if (res.status === 'ok') {
        this.$emit('record-created', this.petmedSuccessMessage(pawerCoverageAmount, res.data, isInGracePeriod));
        this.closeDialog();
        this.refreshParent();
      } else {
        this.creationMsg = this.petmedErrorMessage(res);
        this.snackbar = true;
      }
    },
    // Body de POST /clinics/:clinicId/attendances (specs/021-petmed-droopy-attendance/contracts).
    // Los opcionales vacíos se omiten.
    buildAttendancePayload() {
      const attendance = this.petmedAttendance;
      const pet = this.selectedMembership.pet;
      const line = {
        clinicServiceId: attendance.clinicServiceId,
        service: attendance.serviceId,
        pawerCoverageAmount: attendance.pawerCoverageAmount,
        userPaymentAmount: attendance.userPaymentAmount
      };
      if (this.description) line.description = this.description;
      if (attendance.administeredServiceIds.length) {
        line.administeredServiceIds = attendance.administeredServiceIds;
      }
      const payload = {
        membershipId: this.selectedMembership.id,
        userId: this.selectedUser.id,
        vetId: attendance.vetId,
        name: this.selectedUser.name,
        surname: this.selectedUser.surname,
        petname: pet.name,
        petId: pet.id,
        usedAt: this.usedAt,
        services: [line]
      };
      if (attendance.invoiceReference) payload.invoiceReference = attendance.invoiceReference;
      if (attendance.billReference) payload.billReference = attendance.billReference;
      if (this.userDescription) payload.userDescription = this.userDescription;
      return payload;
    },
    petmedErrorMessage(res) {
      const message = res.message || '';
      if (message.startsWith('SERVICE_NOT_COVERED_BY_MEMBERSHIP_PLAN')) {
        return 'El servicio no está cubierto por el plan de la membresía.';
      }
      if (message.startsWith('PET_NOT_IN_MEMBERSHIP')) {
        return 'La mascota no corresponde a la membresía seleccionada.';
      }
      if (message.startsWith('SERVICE_SPECIES_MISMATCH')) {
        return 'El servicio no corresponde a la especie de la mascota.';
      }
      if (message.startsWith('Doctor with id')) {
        return 'El veterinario no pertenece a la clínica seleccionada.';
      }
      if (message.startsWith('Clinic with id')) return 'La clínica seleccionada no existe.';
      if (res.httpCode === 404) return 'No se encontró el usuario o la membresía.';
      if (res.httpCode === 400) return 'Revisa los datos de la atención e inténtalo nuevamente.';
      return 'Algo salió mal, inténtalo más tarde.';
    },
    // El backend puede recortar la cobertura a 0 por carencia o tope anual sin indicar el motivo;
    // se infiere comparando lo enviado con lo guardado (research Decisión 6). En la edición el
    // tope ya no recorta (FR-024): solo la carencia explica un $0.
    petmedSuccessMessage(sentCoverage, data, isInGracePeriod, verb = 'creado') {
      const lineItem = data && data.invoice && data.invoice.lineItems && data.invoice.lineItems[0];
      const finalCoverage = lineItem ? Number(lineItem.pawerCoverageAmount) : null;
      const reason = isInGracePeriod ? 'período de carencia' : verb === 'creado' ? 'tope anual del plan' : null;
      if (sentCoverage > 0 && finalCoverage === 0 && reason) {
        return `Registro ${verb}. La cobertura Pawer quedó en $0 por ${reason}.`;
      }
      return verb === 'creado' ? 'Nuevo registro creado' : `Registro ${verb}`;
    },
    // Llamado por el padre (vía ref) al abrir el modal, para precargar el
    // filtro de búsqueda que ya está aplicado en la tabla de fondo. Es una
    // copia local: editar el buscador de acá adentro no modifica el filtro
    // de la tabla, solo se usó como valor inicial.
    seedSearch(value) {
      this.search = value || null;
      if (this.search) {
        this.searchReq();
      }
    },
    // Búsqueda del tutor al convertir a PetMed sin membresía: a diferencia de searchReq no
    // llama a clearAll, para no perder lo precargado del registro.
    async pickerSearch() {
      this.loading = true;
      this.noDataMsg = null;
      this.selectedUser = null;
      this.selectedMembership = null;
      try {
        const res = await UsersService.getUsersBySearch(this.search);
        this.usersFinded = res.data.users.filter(user => user.memberships.length > 0);
        if (this.usersFinded.length === 0) this.noDataMsg = 'No se encontraron usuarios';
      } catch (error) {
        this.noDataMsg = 'Algo salió mal, intentalo más tarde';
        console.log(error);
      }
      this.loading = false;
    },
    async searchReq() {
      try {
        this.clearAll();
        this.loading = true;
        this.noDataMsg = null;
        const res = await UsersService.getUsersBySearch(this.search);
        // Solo se muestran usuarios con al menos 1 membresia
        this.usersFinded = res.data.users.filter(user => user.memberships.length > 0);
        this.loading = false;
        if (this.usersFinded.length === 0) {
          this.noDataMsg = 'No se encontraron usuarios';
        }
        this.unregisteredPetName = null;
      } catch (error) {
        this.loading = false;
        this.noDataMsg = 'Algo salió mal, intentalo más tarde';
        console.log(error);
      }
    },
    servicePlanPicked() {
      this.selectedIsolatedService = null;
    },
    isolatedPicked() {
      this.selectedServicePlan = null;
    }
  }
};
</script>
